import { FormattedMessage } from "react-intl";
import EmailLink from "../../../Shared/EmailLink/EmailLink";
import NoDataIndicator from "../../../Shared/NoDataIndicator/NoDataIndicator";
import styles from "./EcgMetaHeader.module.css";
import DialablePhoneLink from "../../../Shared/DialablePhoneLink/DialablePhoneLink";

type EcgMetaHeaderProps = {
  reference: string;
  deviceSerialNumber: string;
  phone?: string;
  email?: string;
  hideContactInfo?: boolean;
};

const EcgMetaHeader = ({
  reference,
  deviceSerialNumber,
  phone,
  email,
  hideContactInfo,
}: EcgMetaHeaderProps) => {
  return (
    <table className="w-100 font-md">
      <tbody>
        <tr>
          <td className={styles.cell}>
            <FormattedMessage id="USER.REFERENCE" defaultMessage="Reference" />:
          </td>
          <td className="p-1"></td>
          <td className={styles.cell}>
            <strong>{reference}</strong>
          </td>
        </tr>
        <tr>
          <td className={styles.cell}>
            <FormattedMessage
              id="SMARTHEART_SN"
              defaultMessage="Smartheart S\N"
            />
            :
          </td>
          <td className="p-1"></td>
          <td className={styles.cell}>
            <strong>{deviceSerialNumber}</strong>
          </td>
        </tr>
        {!hideContactInfo && (
          <tr>
            <td className={styles.cell}>
              <FormattedMessage
                id="USER.CONTACT_INFO"
                defaultMessage="Contact Info"
              />
              :
            </td>
            <td className="p-1"></td>
            <td className={styles.cell}>
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center">
                  {phone ? (
                    <DialablePhoneLink
                      phone={phone}
                      className={styles.dialablePhone}
                    >
                      <i className="fas fa-phone font-sm"></i>
                    </DialablePhoneLink>
                  ) : (
                    <i className="fas fa-phone font-sm"></i>
                  )}
                  &nbsp;
                  {phone ? (
                    <strong>
                      <DialablePhoneLink
                        phone={phone}
                        className={styles.dialablePhone}
                      >
                        {phone}
                      </DialablePhoneLink>
                    </strong>
                  ) : (
                    <NoDataIndicator />
                  )}
                </div>
                &nbsp;
                {email ? (
                  <EmailLink email={email} />
                ) : (
                  <>
                    <i className="far fa-envelope"></i>
                    &nbsp;
                    <NoDataIndicator />
                  </>
                )}
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default EcgMetaHeader;
